import Vue from 'vue'
import Router from 'vue-router'
import config from '@/config'
import store from '@/store'
import { isWeiXin } from '@/utils/tool.js'
import routers from './routers'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)
const router = new Router({
  routes: routers,
  mode: 'history',
  base: process.env.BASE_URL
})
const {
  homeName,
  loginName,
  webLoginName,
  inductionName
} = config

router.beforeEach((to, from, next) => {
  console.log(to.name)
  const LOGIN_PAGE_NAME = store.getters.userInfo.accountType === 3 ? webLoginName : loginName
  const authLogin = store.getters.token
  let ruzhied = false
  if (store.getters.userInfo.accountType !== 1) {
    ruzhied = true
  } else if (store.getters.userAudit === 0) {
      ruzhied = false
  } else if (store.getters.userAudit === -1) {
    ruzhied = false
  } else if (!store.getters.userInfo.entryTime) {
    ruzhied = false
  } else if (store.getters.userInfo.entryTime || store.getters.userAudit === 1 || store.getters.userAudit === -2) {
    ruzhied = true
  }
  if (webLoginName === to.name) {
    if (authLogin) {
      next({ name: homeName })
    } else {
      next()
    }
  } else if (!authLogin && to.name !== LOGIN_PAGE_NAME) {
    // 未登录且要跳转的页面不是登录页
    next({ name: LOGIN_PAGE_NAME })
  } else if (!authLogin && to.name === LOGIN_PAGE_NAME) {
    // 未登陆且要跳转的页面是登录页
    next()
  } else if (authLogin && to.name === LOGIN_PAGE_NAME) {
    // 已登录且要跳转的页面是登录页
    next({ homeName })
  } else if (store.state.hasGetInfo) {
    if (ruzhied) {
      next()
    } else if (to.name === inductionName) {
      next()
    } else {
      next({ name: inductionName })
    }
  } else {
    store.dispatch('getUserInfo').then(res => {
      if (res.status === 200) {
        if (ruzhied) {
          next()
        } else if (to.name === inductionName) {
          next()
        } else {
          next({ name: inductionName })
        }
      } else {
        next({ name: LOGIN_PAGE_NAME })
      }
    }).catch(() => {
      next({ name: LOGIN_PAGE_NAME })
    })
  }
})

router.afterEach(to => {
  window.document.title = to.meta.title
  window.scrollTo(0, 0)
})

export default router
